// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  InlineResponse2001,
  InlineResponse2001FromJSON,
  InlineResponse2001ToJSON,
  ScimCompanyPayload,
  ScimCompanyPayloadFromJSON,
  ScimCompanyPayloadToJSON,
  ScimTokenGenerated,
  ScimTokenGeneratedFromJSON,
  ScimTokenGeneratedToJSON,
  ScimTokenStatus,
  ScimTokenStatusFromJSON,
  ScimTokenStatusToJSON,
  TCError,
  TCErrorFromJSON,
  TCErrorToJSON,
} from "../models";

export interface DisableScimTokenRequest {
  scimCompanyPayload?: ScimCompanyPayload;
}

export interface GenerateScimTokenRequest {
  scimCompanyPayload?: ScimCompanyPayload;
}

export interface GetScimTokenStatusRequest {
  company: number;
}

/**
 * no description
 */
export class ScimProvisioningApi extends runtime.BaseAPI {
  /**
   * Disables SCIM provisioning (the existing token stops working) without deleting the configuration. Caller must be a company administrator.
   * Disable SCIM provisioning for a company
   */
  async disableScimTokenRaw(
    requestParameters: DisableScimTokenRequest
  ): Promise<runtime.ApiResponse<InlineResponse2001>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/scim/admin/token/disable`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ScimCompanyPayloadToJSON(requestParameters.scimCompanyPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InlineResponse2001FromJSON(jsonValue)
    );
  }

  /**
   * Disables SCIM provisioning (the existing token stops working) without deleting the configuration. Caller must be a company administrator.
   * Disable SCIM provisioning for a company
   */
  async disableScimToken(
    requestParameters: DisableScimTokenRequest
  ): Promise<InlineResponse2001> {
    const response = await this.disableScimTokenRaw(requestParameters);
    return await response.value();
  }

  /**
   * Creates a new SCIM bearer token (invalidating any previous one) and returns the plaintext exactly once. Only the token hash is stored. Caller must be a company administrator.
   * Generate or rotate the SCIM provisioning token for a company
   */
  async generateScimTokenRaw(
    requestParameters: GenerateScimTokenRequest
  ): Promise<runtime.ApiResponse<ScimTokenGenerated>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/scim/admin/token`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ScimCompanyPayloadToJSON(requestParameters.scimCompanyPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ScimTokenGeneratedFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new SCIM bearer token (invalidating any previous one) and returns the plaintext exactly once. Only the token hash is stored. Caller must be a company administrator.
   * Generate or rotate the SCIM provisioning token for a company
   */
  async generateScimToken(
    requestParameters: GenerateScimTokenRequest
  ): Promise<ScimTokenGenerated> {
    const response = await this.generateScimTokenRaw(requestParameters);
    return await response.value();
  }

  /**
   * Returns whether SCIM provisioning is enabled/configured for the company. Never returns the token. Caller must be a company administrator.
   * Get SCIM provisioning token status for a company
   */
  async getScimTokenStatusRaw(
    requestParameters: GetScimTokenStatusRequest
  ): Promise<runtime.ApiResponse<ScimTokenStatus>> {
    if (
      requestParameters.company === null ||
      requestParameters.company === undefined
    ) {
      throw new runtime.RequiredError(
        "company",
        "Required parameter requestParameters.company was null or undefined when calling getScimTokenStatus."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.company !== undefined) {
      queryParameters["company"] = requestParameters.company;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/scim/admin/token`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ScimTokenStatusFromJSON(jsonValue)
    );
  }

  /**
   * Returns whether SCIM provisioning is enabled/configured for the company. Never returns the token. Caller must be a company administrator.
   * Get SCIM provisioning token status for a company
   */
  async getScimTokenStatus(
    requestParameters: GetScimTokenStatusRequest
  ): Promise<ScimTokenStatus> {
    const response = await this.getScimTokenStatusRaw(requestParameters);
    return await response.value();
  }
}
